import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { daoMeGet } from 'dao/iam-dao';
import { Action } from 'types/action';
import { IAmReq, IamState, Me } from 'types/iam';
import { Thunk } from 'types/root';

export const getMeDetails = createAsyncThunk<Me, IAmReq | void, Thunk>(
  'iAm/getMe',
  async (payload: IAmReq | void, thunkAPI) => {
    try {
      const { childAccountKey, managedAccountKey } = payload || {};
      return await daoMeGet(childAccountKey, managedAccountKey);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

const initialState: IamState = {
  isLoading: false,
  me: {} as Me,
};

const iamDetailsSlice = createSlice({
  name: 'me-details',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getMeDetails.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMeDetails.fulfilled, (state, action: Action) => {
        state.me = action.payload;
        state.isLoading = false;
      })
      .addCase(getMeDetails.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default iamDetailsSlice.reducer;
